import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { fromJS } from 'immutable';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';

import ProductCategory from '../common/product-category';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import TagFilter from '../common/tagFilter';
import Showcase from '../common/showcase';
@connect(({ vpn: { offers } }) => ({ offers }))
@withRouter
class Offers extends ProductCategory {
  constructor(props) {
    super(props);

    this.state = this.mapPropsToState(props, {
      offerType: 'vpn',
      ...this.state,
      defaultFilters: { // FOR FILTERS_USED EPI
        tags: []
      },
      filters: {
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      tags: []
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }

  serialiseOffer(offer) {
    const tags = [
      offer.get('serverLocation'),
      offer.getIn(['price', 'startup']) === 0 ? 'Gratis oprettelse' : null
    ].concat(offer.get('tags').toJS()).filter(Boolean);

    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags || []).filter(Boolean);

    const result = fromJS({
      id: offer.get('_id'),

      provider: offer.get('provider'),
      product: offer.get('product'),
      logo:
        offer.getIn(['image', 'hash']) &&
        `${config.images}${offer.getIn(['image', 'hash'])}`,
      link: `/redirect/${offer.get('uuid')}`,
      tagline: offer.get('tagline'),
      orderText: 'Gå til udbyder',

      details: [
        {
          value: offer.get('periodMonth') || '-', 
          unit: 'md.',
          size: '1/4',
          label: 'Normal periode'
        },
        {
          value: offer.get('extraMonth'),
          unit: 'md.',
          size: '1/4',
          label: 'Ekstra periode'
        },
        {
          value: offer.get('totalPeriod') || '-',
          unit: 'md.',
          size: '1/4',
          label: 'Periode i alt'
        },
        {
          value: offer.get('rightOfWithdrawel') || '-',
          unit: 'dage',
          size: '1/4',
          label: 'Fortrydelsesret'
        },
        {
          value: offer.get('servers') || '-', 
          unit: '',
          size: '1/4',
          label: 'Antal servere'
        },
        {
          value: offer.get('countries') || '-',
          unit: '',
          size: '1/4',
          label: 'Lande'
        },
        {
          value: offer.get('encryption') || '-',
          unit: '',
          size: '1/4',
          label: 'Kryptering'
        },
        {
          value: offer.get('logPolicy') || '-',
          unit: '',
          size: '1/4',
          label: 'Log politik'
        }
      ].filter(Boolean),

      price: {
        value: offer.getIn(['price', 'monthly']) || '-',
        unit: 'kr.',
        label: 'per måned'
      },

      usps: []
        .concat(mergedTags, offer.get('services').toJS())
        .filter(Boolean),

      productDescription: offer.get('productDescription'),
      discountCode: offer.get('discountCode'),
      tags: tags.map((v) => typeof v === 'string' ? v.trim(): '').filter(Boolean),

      _raw: offer
    });

    return result;
  }

  createFilter(filters) {
    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.get('usps'));
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const filteredTags = filters.tags;
        
        const lowerCaseTags = tags.map(i => i.toLowerCase());
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !tags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider) {
            return false;
          }
        }

        return true;
      });
  }

  render() {
    const { offers, filter, filters, showcases } = this.state;

    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'VPN'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Gå til udbyder' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default Offers;
